import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectFinancialEntityNamesState } from '../selectors';

export const getData = createSelector(selectFinancialEntityNamesState, (state: State) => state.data);

export const getError = createSelector(selectFinancialEntityNamesState, (state: State) => state.error);

export const getLoading = createSelector(selectFinancialEntityNamesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectFinancialEntityNamesState, (state: State) => fn(state.data));
